import { NativeModules } from 'react-native';
import { useNavigationState } from './useNavigationState';
import { useLatest, useMemoizedFn } from 'ahooks';

/**
 * 由于这个方法会被多个地方调用，为保证相互之间不冲突，引入优先级，优先级为：容器粒度 > 页面粒度 > 组件粒度
 */
export function useSlideBack() {
    const navState = useNavigationState((s) => s);
    const len = navState?.routes?.length || 1;

    const setSlideBack = useMemoizedFn((initialEnable: number | boolean = true) => {
        // 只有路由为1的时候才处理容器，否则不处理容器
        if (len === 1) {
            if (initialEnable) {
                NativeModules?.KRNBasic?.setSlideBack?.({
                    enabled: true, //  true: 打开滑动返回  false ：关闭滑动返回
                });
                console.log('打开右滑关闭容器');
            } else {
                NativeModules?.KRNBasic?.setSlideBack?.({
                    enabled: false, //  true: 打开滑动返回  false ：关闭滑动返回
                });
                console.log('关闭右滑关闭容器');
            }
        }
    });

    return {
        setSlideBack,
    };
}
